module.exports = __webpack_public_path__ + "static/media/pic4.a24b97e9.jpg";